import { errorHandler } from '../../../util/error.service'
import * as routes from '../../routes/registration.routes'
import { authHttp } from '../http'

export async function saveVehicleTransfer(veiculoTransferencia, tp_id) {
  try {
    const response = await authHttp().post(
      routes.urlSaveVehicleTransfer(tp_id),
      veiculoTransferencia,
    )
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function updateVehicleTransfer(veiculoTransferencia) {
  try {
    const response = await authHttp().put(routes.urlUpdateVehicleTransfer(), veiculoTransferencia)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getVehiclesTransfer(tp_id) {
  try {
    const response = await authHttp().get(routes.urlGetVehiclesTransfer(tp_id))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function deleteVehicleTransfer(tpId, veiculoTransferenciaId) {
  try {
    const response = await authHttp().delete(
      routes.urlDeleteVehicleTransfer(tpId, veiculoTransferenciaId),
    )
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}
